import React from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import api from "./Api/api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const Login = () => {
  const dispatch = useDispatch();
  const checkoutstatus = useSelector((state) => state.checkoutstatus);
  const { auth, setAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showSignup, setShowSignup] = useState(false);
  const [user, setUser] = useState();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [guestEmail, setGuestEmail] = useState("");

  const navigate = useNavigate();

  const { data: cartdata, refetch: cartrefetch } = useQuery(
    ["logdata"],
    () => api.get(`users/getcartitems/${user}`),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: false,

      select: (res) => res.data,
    }
  );

  const { data: packagedata, refetch: packrefetch } = useQuery(
    ["packdata"],
    () => api.get(`users/getpackageitems/${user}`),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: false,

      select: (res) => res.data,
    }
  );

  const mutationlogin = useMutation(
    (body) => {
      const headers = {
        headers: {
          "content-type": "application/json",
        },
      };
      return api.post("admin/userlogin", body, headers);
    },
    {
      onError: (error, variables, context) => {
        console.log(error);
        toast.error("Login failed. Please check your credentials.", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
      // Update the mutationlogin success handler
      onSuccess: (data, variables, context) => {
        if (data.data.status) {
          console.log("info", data.data);
          setAuth({ user: data.data });
          var user = { id: data.data.userid?.id };
          localStorage.setItem("user", JSON.stringify(user));
          setUser(data.data.userid?.id);
          localStorage.setItem("token", data.data.refreshtoken);

          toast.success("Login successful!", {
            position: toast.POSITION.TOP_CENTER,
          });

          // ✅ Refetch cart and packages
          setTimeout(() => {
            cartrefetch();
            packrefetch();
          }, 500);

          // ✅ Navigate based on checkout status after a short delay
          setTimeout(() => {
            if (checkoutstatus) {
              // User was trying to checkout, send to address/details
              navigate("/details");
            } else {
              // Normal login, send to homepage
              navigate("/");
            }
          }, 700);
        } else {
          toast.error("Invalid credentials. Please sign up.", {
            position: toast.POSITION.TOP_CENTER,
          });
          setShowSignup(true);
        }
      },
    }
  );

  const mutationsignup = useMutation(
    (body) => {
      const headers = {
        headers: {
          "content-type": "application/json",
        },
      };
      return api.post("admin/usersignup", body, headers);
    },
    {
      onError: (error, variables, context) => {
        console.log(error);
        toast.error("Signup failed. Please try again.", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
      // Update the mutationsignup success handler similarly
      onSuccess: (data, variables, context) => {
        if (data.data.status) {
          setAuth({ user: data.data });
          var user = { id: data.data.userid };
          localStorage.setItem("user", JSON.stringify(user));
          setUser(data.data.userid);
          localStorage.setItem("token", data.data.refreshtoken);

          toast.success("Account created successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });

          // ✅ Navigate based on checkout status
          setTimeout(() => {
            if (checkoutstatus) {
              navigate("/details");
            } else {
              navigate("/");
            }
          }, 500);
        } else {
          toast.error("Signup failed. Email may already exist.", {
            position: toast.POSITION.TOP_CENTER,
          });
          setShowSignup(true);
        }
      },
    }
  );

  const mutationguest = useMutation(
    (body) => {
      const headers = {
        headers: {
          "content-type": "application/json",
        },
      };
      return api.post("admin/guest", body, headers);
    },
    {
      onError: (error, variables, context) => {
        console.log(error);
        toast.error("Guest checkout failed. Please try again.", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
      onSuccess: (data, variables, context) => {
        if (data.data.status) {
          setAuth({ user: data.data });
          var user = { id: data.data.userid };
          localStorage.setItem("user", JSON.stringify(user));
          setUser(data.data.userid);
          localStorage.setItem("token", data.data.refreshtoken);
          toast.success("Proceeding as guest!", {
            position: toast.POSITION.TOP_CENTER,
          });
          navigate("/details");
        } else {
          toast.error("Guest checkout failed.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      },
    }
  );

  useEffect(() => {
    cartdata?.data?.forEach((item) => {
      dispatch({ type: "ADD_TO_CART", payload: item });
    });
  }, [cartdata]);

  useEffect(() => {
    packagedata?.data?.forEach((item) => {
      dispatch({ type: "ADD_PACKAGES", payload: item });
    });
  }, [packagedata]);

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    // Validation
    if (!email || !password) {
      toast.error("Email and password are required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    var body = { username: email, password: password };
    mutationlogin.mutate(body);
  };

  const handleSignup = (e) => {
    e.preventDefault();

    // Validation
    if (!name || !mobile || !email || !password) {
      toast.error("All fields are required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (mobile.length < 11) {
      toast.error("Mobile number should be at least 11 digits", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (password.length < 6) {
      toast.error("Password should be at least 6 characters", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    var body = { name, mobile, username: email, password: password };
    mutationsignup.mutate(body);
  };

  const handleGuest = (e) => {
    e.preventDefault();

    // Validation - Email is MANDATORY for guest checkout
    if (!guestEmail || guestEmail.trim() === "") {
      toast.error("Email is required for guest checkout", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!validateEmail(guestEmail)) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    var body = { username: guestEmail };
    mutationguest.mutate(body);
  };

  return (
    <div>
      <div className="login-banner">
        <div className="container">
          <div className="row">
            {showSignup ? (
              <div className="col-md-4">
                <div className="login-inner">
                  <form onSubmit={handleSignup}>
                    <h2 className="heading">Sign Up</h2>
                    <div className="mb-3">
                      <label htmlFor="signupName" className="form-label">
                        Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="signupName"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="signupMobile" className="form-label">
                        Mobile <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="signupMobile"
                        required
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        placeholder="07123456789"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="signupEmail" className="form-label">
                        Email address <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="signupEmail"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="email@example.com"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="signupPassword" className="form-label">
                        Password <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="signupPassword"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Minimum 6 characters"
                      />
                    </div>
                    <button type="submit" className="btn btn-light-large mt-2">
                      Sign Up
                    </button>

                    <p className="loginText">
                      Already have an account?{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowSignup(false);
                        }}
                      >
                        Log In Now
                      </a>
                    </p>
                  </form>
                </div>
              </div>
            ) : (
              <div className="col-md-4">
                <div className="login-inner">
                  <form onSubmit={handleLogin}>
                    <h2 className="heading">Log In</h2>
                    <div className="mb-3">
                      <label htmlFor="loginEmail" className="form-label">
                        Email address <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="loginEmail"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="email@example.com"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="loginPassword" className="form-label">
                        Password <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="loginPassword"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="btn btn-light-large mt-2">
                      Log In
                    </button>
                    <p className="loginText">
                      Don't have an account?{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowSignup(true);
                        }}
                      >
                        Register Now
                      </a>
                    </p>
                  </form>
                </div>
              </div>
            )}
            <div className="col-md-2"></div>
            {checkoutstatus ? (
              <div className="col-md-4">
                <div className="login-inner">
                  <form onSubmit={handleGuest}>
                    <h2 className="heading">Guest Checkout</h2>
                    <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                      Checkout without creating an account
                    </p>
                    <div className="form-group mb-3">
                      <label htmlFor="guestEmail" className="form-label">
                        Email address <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="guestEmail"
                        required
                        value={guestEmail}
                        onChange={(e) => setGuestEmail(e.target.value)}
                        placeholder="email@example.com"
                      />
                      <small className="form-text text-muted">
                        Order confirmation will be sent to this email
                      </small>
                    </div>
                    <button type="submit" className="btn btn-light-large mt-2">
                      Guest CheckOut
                    </button>
                  </form>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
